/**
 * Centraliserad robots-meta-komponent.
 *
 * Använd ALLTID denna istället för:
 *   <meta name="robots" content="noindex, nofollow" />
 *
 * Det säkerställer:
 *  - Konsekvent format ("noindex, follow" osv.)
 *  - Single source of truth för vilken policy som hör till vilken sidtyp
 *  - Att frontend (Helmet) och backend (render-meta worker) håller samma logik
 */
import { Helmet } from "react-helmet";
import { ROBOTS_CONTENT, type RobotsPolicy } from "@/lib/seo/robotsPolicy";

interface RobotsMetaProps {
  /** Vilken policy som ska gälla. */
  policy: RobotsPolicy;
  /**
   * Valfri kontextflagga som dynamiskt tvingar noindex-follow,
   * t.ex. för OOS-produkter eller filtrerade vyer.
   */
  forceNoindexFollow?: boolean;
}

export function RobotsMeta({ policy, forceNoindexFollow }: RobotsMetaProps) {
  const effectivePolicy: RobotsPolicy = forceNoindexFollow ? "noindex-follow" : policy;
  const content = ROBOTS_CONTENT[effectivePolicy];
  return (
    <Helmet>
      <meta name="robots" content={content} />
    </Helmet>
  );
}
